import ProductManagement from './ProductManagement';
export { default as productManagementReducer } from './reducers';
export * from './reducers/type';
export * from './reducers';

export default ProductManagement;
